export const findSelectPortalMenus = (containerEl: Element): Element[] => {
  // TODO: this runs on every DOM mutation via MutationObserver in useTargetPosition.
  // If containerEl contains many react-select inputs, we should check if it can cause performance issue.
  const inputs = containerEl.querySelectorAll('input[id^="react-select-"]');
  if (inputs.length === 0) return [];

  const portal = document.getElementById('react-select-portal');
  if (!portal) return [];

  const menus: Element[] = [];

  inputs.forEach((input) => {
    const inputId = input.getAttribute('id') || '';
    const instancePrefix = inputId.replace('-input', '');
    if (!instancePrefix) return;

    const matchingOption = portal.querySelector(`[id^="${instancePrefix}-option-"]`);
    if (!matchingOption) return;

    const menu = matchingOption.closest('[class*="-menu"]') || portal.firstElementChild;
    if (menu && !menus.includes(menu)) {
      menus.push(menu);
    }
  });

  return menus;
};

export const findDatepickerPortal = (containerEl: Element): Element | null => {
  const hasDatepicker = containerEl.querySelector('.react-datepicker__input-container');
  if (!hasDatepicker) return null;

  const portal = document.getElementById('datepicker-portal');
  if (!portal) return null;

  const popper = portal.querySelector('.react-datepicker-popper');
  return popper || null;
};

export const findMultiSelectDropdowns = (containerEl: Element): Element[] => {
  const dropdowns = containerEl.querySelectorAll('.dropdown-content');
  const visible: Element[] = [];

  dropdowns.forEach((dropdown) => {
    if (dropdown.children.length > 0) {
      visible.push(dropdown);
    }
  });

  return visible;
};

export const findMultiFilterPortal = (containerEl: Element): Element | null => {
  const portal = document.getElementById('multifilter-portal');
  if (!portal) return null;

  const openDropdown = portal.querySelector('[open]');
  if (!openDropdown) return null;

  const wrapper = openDropdown.parentElement;
  if (!wrapper) return openDropdown;

  const dropdownLeft = parseFloat(wrapper.style.left || '-1');
  const containerRect = containerEl.getBoundingClientRect();

  if (dropdownLeft >= containerRect.left && dropdownLeft <= containerRect.right) {
    return openDropdown;
  }

  return null;
};
